/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Input,
} from '@angular/core';
import _ from 'lodash';
import { highlightHtml } from '../pipes/highlight-html';

// A person in the search results: links to their profile, with a Follow button for other people.
@Component({
  selector: 'ut-search-person-card',
  templateUrl: './search-person-card.component.html',
  styleUrls: ['./search-person-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchPersonCardComponent {
  @Input({ required: true }) person: any;
  @Input({ required: true }) user: any;
  // Search terms to mark in the subtitle.
  @Input() highlight = '';

  get isYou(): boolean {
    return !!this.user && this.person.id === this.user.id;
  }

  get subtitle(): string {
    return [this.person.user_title, this.person.country?.name].filter(Boolean).join(' · ');
  }

  // Escaped before marking, so a name or title can't inject markup.
  get subtitleHtml(): string {
    return highlightHtml(_.escape(this.subtitle), this.highlight);
  }

  get canFollow(): boolean {
    return !this.isYou && !!this.person.current_user_permissions?.follow;
  }

  get headingId(): string {
    return `person_${this.person.id}`;
  }
}
